import {
  HIDE_CANCEL_EQUEUE_LOADER,
  HIDE_CONFIRM_LOADER,
  HIDE_DATES_LOADER,
  HIDE_DOCTOR_NAMES_LOADER,
  HIDE_DOCTORS_LOADER,
  HIDE_EQUEUES_LOADER,
  HIDE_LOGIN_FORM_LOADER,
  HIDE_MOSCOW_SCENARIO_LOADER,
  HIDE_REGIONS_LOADER,
  HIDE_SELECTED_EQUEUE_LOADER,
  HIDE_USER_INFO_LOADER,
  SET_DEFAULT_VALUE,
  SHOW_CANCEL_EQUEUE_LOADER,
  SHOW_CONFIRM_LOADER,
  SHOW_DATES_LOADER,
  SHOW_DOCTOR_NAMES_LOADER,
  SHOW_DOCTORS_LOADER,
  SHOW_EQUEUES_LOADER,
  SHOW_LOGIN_FORM_LOADER,
  SHOW_MOSCOW_SCENARIO_LOADER,
  SHOW_REGIONS_LOADER,
  SHOW_SELECTED_EQUEUE_LOADER,
  SHOW_USER_INFO_LOADER,
} from "../actions/types";

const defaultState = {
  showLoginFormLoader: false,
  showQueuesLoader: false,
  showCancelEqueueLoader: false,
  showSelectedEqueueLoader: false,
  showUserInfoLoader: false,
  showDoctorsLoader: false,
  showDoctorNamesLoader: false,
  showDatesLoader: false,
  showConfirmLoader: false,
  showRegionsLoader: false,
  showBookingLoader: false,
  showMoscowScenarioLoader: false,
};
const updateLoader = (state, action) => {
  if (state === undefined) {
    return defaultState;
  }
  switch (action.type) {
    case SHOW_LOGIN_FORM_LOADER:
      return {
        ...state.loader,
        showLoginFormLoader: true,
      };
    case HIDE_LOGIN_FORM_LOADER:
      return {
        ...state.loader,
        showLoginFormLoader: false,
      };
    case SHOW_EQUEUES_LOADER:
      return {
        ...state.loader,
        showQueuesLoader: true,
      };
    case HIDE_EQUEUES_LOADER:
      return {
        ...state.loader,
        showQueuesLoader: false,
      };
    case SHOW_SELECTED_EQUEUE_LOADER:
      return {
        ...state.loader,
        showSelectedEqueueLoader: true,
      };
    case HIDE_SELECTED_EQUEUE_LOADER:
      return {
        ...state.loader,
        showSelectedEqueueLoader: false,
      };
    case SHOW_CANCEL_EQUEUE_LOADER:
      return {
        ...state.loader,
        showCancelEqueueLoader: true,
      };
    case HIDE_CANCEL_EQUEUE_LOADER:
      return {
        ...state.loader,
        showCancelEqueueLoader: false,
      };
    case SHOW_USER_INFO_LOADER:
      return {
        ...state.loader,
        showUserInfoLoader: true,
      };
    case HIDE_USER_INFO_LOADER:
      return {
        ...state.loader,
        showUserInfoLoader: false,
      };
    case SHOW_DOCTORS_LOADER:
      return {
        ...state.loader,
        showDoctorsLoader: true,
      };
    case HIDE_DOCTORS_LOADER:
      return {
        ...state.loader,
        showDoctorsLoader: false,
      };
    case SHOW_DOCTOR_NAMES_LOADER:
      return {
        ...state.loader,
        showDoctorNamesLoader: true,
      };
    case HIDE_DOCTOR_NAMES_LOADER:
      return {
        ...state.loader,
        showDoctorNamesLoader: false,
      };
    case SHOW_DATES_LOADER:
      return {
        ...state.loader,
        showDatesLoader: true,
      };
    case HIDE_DATES_LOADER:
      return {
        ...state.loader,
        showDatesLoader: false,
      };
    case SHOW_CONFIRM_LOADER:
      return {
        ...state.loader,
        showConfirmLoader: true,
      };
    case HIDE_CONFIRM_LOADER:
      return {
        ...state.loader,
        showConfirmLoader: false,
      };
    case SHOW_REGIONS_LOADER:
      return {
        ...state.loader,
        showRegionsLoader: true,
      };
    case HIDE_REGIONS_LOADER:
      return {
        ...state.loader,
        showRegionsLoader: false,
      };
    case SHOW_MOSCOW_SCENARIO_LOADER:
      return {
        ...state.loader,
        showMoscowScenarioLoader: true,
      };
    case HIDE_MOSCOW_SCENARIO_LOADER:
      return {
        ...state.loader,
        showMoscowScenarioLoader: false,
      };
    case SET_DEFAULT_VALUE:
      return {
        ...defaultState,
      };
    default:
      return {
        ...state.loader,
      };
  }
};

export default updateLoader;
